import axios from "axios";
import {
  CONTRACT_ALL_ACTIONS_TYPE,
  CONTRACT_MODAL_ACTION_TYPE,
} from "../actions-type";
import { toast } from "react-toastify";
import { logoutAction } from "./auth";
import { apiRoot } from "../../apiRoot";

const API = axios.create({
  baseURL: `${apiRoot}/contract`,
  withCredentials: true,
});
API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

// const refreshApi = axios.create({
//   baseURL: `${apiRoot}/user/auth/refresh_token`,
//   withCredentials: true,
// });

const toastSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
const toastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    toastClassName: "custom-toast",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
const setLoadingContractAction = (loadingValue) => ({
  type: CONTRACT_ALL_ACTIONS_TYPE.CONTRACT_LOADING,
  payload: loadingValue,
});
const modalLoading = (loadingValue) => ({
  type: CONTRACT_MODAL_ACTION_TYPE.CONTRACT_MODAL_LOADING,
  payload: loadingValue,
});

const contractModalOpen = (value) => ({
  type: CONTRACT_MODAL_ACTION_TYPE.CONTRACT_OPEN_MODAL,
  payload: value,
});

export const getDropdownContractsAction = () => async (dispatch) => {
  try {
    const { data } = await API.get("/dropdown");
    dispatch({ type: CONTRACT_ALL_ACTIONS_TYPE.GET_CONTRACTS, payload: data });
  } catch (error) {
    if (error?.response?.status === 403) {
      dispatch(logoutAction());
    }
  }
};

export const getContractsAction = () => async (dispatch) => {
  dispatch(setLoadingContractAction(true));

  try {
    const { data } = await API.get(`/`);
    dispatch({
      type: CONTRACT_ALL_ACTIONS_TYPE.GET_CONTRACTS,
      payload: data,
    });
  } catch (error) {
    console.log(error);

    if (error?.response?.status === 403) {
      dispatch(logoutAction());
    }
  } finally {
    dispatch(setLoadingContractAction(false));
  }
};

export const createContractAction = (newData) => async (dispatch) => {
  dispatch(modalLoading(true));

  console.log("salam in action");
  try {
    const { data } = await API.post("/", newData);

    console.log("salam in action 2");
    dispatch({
      type: CONTRACT_ALL_ACTIONS_TYPE.CREATE_CONTRACT,
      payload: data,
    });
    dispatch(contractModalOpen(false));
    toastSuccess("Yeni müqavilə yaradıldı");
  } catch (error) {
    if (error?.response?.status === 403) {
      dispatch(logoutAction());
    }

    if (error?.response?.data?.key === "existing-contract") {
      toastError("Bu müqavilə növü artıq mövcuddur");
    }
  } finally {
    dispatch(modalLoading(false));
  }
};

export const updateContractAction = (_id, newData) => async (dispatch) => {
  dispatch(modalLoading(true));

  try {
    const { data } = await API.patch(`/${_id}`, newData, {
      "Content-Type": "multipart/form-data",
    });

    dispatch({
      type: CONTRACT_ALL_ACTIONS_TYPE.UPDATE_CONTRACT,
      payload: data,
    });
    dispatch(contractModalOpen(false));
    toastSuccess("Müqavilə yeniləndi");
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      return dispatch(logoutAction());
    }

    if (error?.response?.data?.key === "existing-contract") {
      toastError("Bu müqavilə növü artıq mövcuddur");
    }
  } finally {
    dispatch(modalLoading(false));
  }
};

export const downloadContractAction = (data) => async (dispatch) => {
  try {
    if (!data.fileName) {
      toastError("Fayl mövcud deyil");
      return;
    }

    const response = await API.get(`/${data._id}/download`, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = data.name || "";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toastError("Fayl endirilmədi");
  }
};
